var map = {
	"./add-white.svg": "47bb",
	"./add.svg": "d6be",
	"./business-finance-white.svg": "f054",
	"./business-finance.svg": "9a65",
	"./car-wash-white.svg": "c075",
	"./car-wash.svg": "d854",
	"./pencil-white.svg": "332f",
	"./pencil.svg": "d2df",
	"./protection-white.svg": "f868",
	"./protection.svg": "eba9",
	"./tools-white.svg": "0572",
	"./tools.svg": "1ebc",
	"./wash-white.svg": "4c36",
	"./wash.svg": "6573",
	"./wheel-white.svg": "4936",
	"./wheel.svg": "6d99",
	"./windscreen-air-white.svg": "c6ce",
	"./windscreen-air.svg": "070d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "db79";